module.exports = __webpack_public_path__ + "static/img/ai.043b94fc.png";